<template>
	<span>
		<header class="col-xs-12 npd podcast__header">
			<div class="container">
				<div class="row">
					<h2>REFLEXIONES</h2>
					<ul class="col-xs-12 filtro" v-if="loaded_categorias=='true'">
						<li class="active">
							<router-link :to="{ name: 'archive_reflexiones' }" >
								Todos
							</router-link>
						</li>
						<li v-for="categoria in categorias" class="nonactive" v-bind:elpodcast="categoria.slug">
							<router-link :to="{ name: 'interna_reflexion', params: { name:categoria.slug } }" >
								{{ categoria.name }}
							</router-link>
							<!-- <router-link v-else :to="{ name: 'catpodcast' }" >
								{{ categoria.name }}
							</router-link> -->

						</li>
					</ul>
				</div>
			</div>
		</header>
		<div class="col-xs-12 block npd ">
			<div class="container">
				<div class="row">
					<!-- ITEM -->
					<div v-if="loaded_categorias==='true'">
						<div v-for="categoria in categorias" class="col-xs-12 col-xs-6 progitem progitem--podcast">
							<div class="col-xs-12 npd progitem__wrap paused">
								<div class="progitem__titulo">
									<h3>{{categoria.name}}</h3>

									<router-link :to="{ name: 'interna_reflexion', params: { name:categoria.slug } }" class="todo">
											ver todo
									</router-link>
						
								</div>
								<router-link :to="{ name: 'interna_reflexion', params: { name: categoria.slug }}" class="toint">
									
									<figure>
										<img v-if="categoria.categoria_meta.icono.sizes.hasOwnProperty('medium_large')" v-bind:src="categoria.categoria_meta.icono.sizes['medium_large']">
										<img v-else v-bind:src="theme_url+'/html/assets/img/imgplay.jpg'" >
										<div class="flex-centermid progitem__des">
											 
										</div>
									</figure>

								</router-link>
								<!--
								<div class="reflexiones__title paused">
									<button v-if="categoria.categoria_meta.last_post != null" v-bind:audio="categoria.categoria_meta.last_post.audio" class="reflexiones__player flex-centermid btn">
									 	<i class="icon play-mini-white"></i>
									</button>
								</div>
								-->
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</span>
</template>

<script>
export default {
	mounted: function() {
		const vm = this;
		//vm.getProgramas();
		//vm.getProgramasSticky();
		vm.getCatId( 'reflexion' );

	},
	data() {
		return {
			theme_url:rtwp.theme_url,
			programas: {},
			programas_sticky: {},
			loaded: 'false',
			loaded_sticky: 'false',
			posts: {},
			sticky: {},
			loaded_posts: 'false',
			pageTitle: '',
			totalCount: '',
			catName: '',
			LaCat: '',
			locutores:[],
			audios:{},
			currentPage: '',
			prevPage: '',
			nextPage: '',
			showNext: 'false',
			showPrev: 'false',
			postPerPage: '6',
			totalPages: '',
			categorias: {},
			loaded_categorias: 'false',
		};
	},
	methods: {
		getProgramas: function(  ) {
			const vm = this;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/programas?per_page=99')
			.then( ( res ) => {
				vm.programas = res.data;
				vm.loaded = 'true';
				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();
				});
				//console.log(vm.programas);
				
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		getProgramasSticky: function(  ) {
			const vm = this;
			vm.loaded_sticky = 'false';
			vm.$http.get( 'programas/sticky')
			.then( ( res ) => {
				vm.programas_sticky = res.data;
				vm.loaded_sticky = 'true';
				vm.$nextTick(function(){
					init_attach();
				});
				//console.log(vm.programas_sticky);
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		getPosts: function( catId, pageNumber = 1 ) {
			const vm = this;
			vm.loaded_posts = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { categories: catId, page: pageNumber,per_page: vm.postPerPage }
			} )
			.then( ( res ) => {
				vm.posts = res.data;
				vm.loaded_posts = 'true';
				vm.totalPages = res.headers[ 'x-wp-totalpages' ];
				vm.showNext='true';
				vm.showPrev='true';
				if ( pageNumber <= parseInt( vm.totalPages ) ) {
					vm.currentPage = parseInt( pageNumber );
				} else {
					vm.currentPage = 1;
				}
				vm.$nextTick(function(){
					activar_slick_reflexiones_portada();
					setTimeout(function(){
						jQuery('div.reflexiones__title').on('click','button.reflexiones__player', function(event) {
							event.preventDefault();
							var self=this;
							var audio=jQuery('#elementodeaudio');
							var estado=jQuery(self).parent().hasClass('paused');
							if(estado!=true){
								jQuery('div.reflexiones__title').addClass('paused');
								jQuery(audio).trigger('pause');
							} else {
								jQuery(audio).prop('src',jQuery(self).attr('audio'));
								jQuery(self).parent().removeClass('paused');
								jQuery(audio).trigger('play');

							}
						});
					},500);
					init_attach();
				});
				console.log('LEPOST');
				console.log(vm.posts);
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getSticky: function( catId ) {
			const vm = this;
			vm.loaded_sticky = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { categories: catId, sticky:true }
			} )
			.then( ( res ) => {
				vm.sticky = res.data;
				vm.loaded_sticky = 'true';
				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getCatId: function( name ) {
			const vm = this;
			console.log(name);
			vm.catName = name;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/categories/?slug=' + name )
			.then( ( res ) => {
				vm.totalCount = (res.count);
				res = res.data[ 0 ];
				vm.catName=res.name;
				vm.pageTitle = vm.catName;
				vm.$store.commit( 'rtChangeTitle', vm.pageTitle );
				vm.getPosts( res.id );
				vm.getSticky( res.id );
				vm.LaCat=res;
				this.getCats(res.id);
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		getCats:function (pid){
			// http://104.236.216.165/wp-json/wp/v2/categories/
			const vm = this;
			vm.loaded_categorias = 'false';
			vm.$http.get( 'wp/v2/categories/', {
				params: { hide_empty: true, parent:pid }
			} )
			.then( ( res ) => {
				vm.loaded_categorias='true';
				vm.categorias=res.data;
				vm.$nextTick(function(){
					jQuery("li[elpodcast='"+vm.LaCat.slug+"']").addClass('active');
				});
				console.log(vm.categorias);
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		rtShowNext: function( event ) {
			const vm = this;
			if ( vm.currentPage < vm.totalPages ) {
				vm.currentPage = vm.currentPage + 1;
				vm.getPosts(vm.LaCat.id,vm.currentPage);
				//vm.$router.push( { 'name': 'category', params: { categories: vm.LaCat.id, page: vm.currentPage,per_page: vm.postPerPage } } );
			}
		},
		rtShowPrev: function( event ) {
			const vm = this;
			if ( vm.currentPage != 1 ) {
				vm.currentPage = vm.currentPage - 1;
				vm.getPosts(vm.LaCat.id,vm.currentPage);
				//vm.$router.push( { 'name': 'category', params: { categories: vm.LaCat.id, page: vm.currentPage,per_page: vm.postPerPage } } );
			}
		},
		rtShowFirst: function( event ) {
			const vm = this;
				vm.getPosts(vm.LaCat.id,1);
		},
		rtShowLast: function( event ) {
			const vm = this;
				vm.getPosts(vm.LaCat.id,vm.totalPages);
		},
		getAudios: function( programaid ) {
			const vm = this;
			vm.loaded_audios = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { elprograma: programaid, per_page:1,category:7 }
			} )
			.then( ( res ) => {
				vm.audios= res.data;
				// window._data=res.data;
				if(res.data.length>0){
					vm.loaded_audios = 'true';
				}
				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();
					console.log(vm.audios);
				});
				
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		}
	}
};
</script>
	


// WEBPACK FOOTER //
// archive_reflexiones.vue?3498891e